<template>
    <div>
        <CRow>
            <CCol xs="12" sm="12" md="4" lg="4" xl="3">
                <CCard>
                    <CCardHeader class="d-flex justify-content-between">
                        <b><i class="fas fa-calendar"></i>&nbsp;Movimiento entre almacenes</b>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol sm="12">
                                <CSelect label="Almacenes" :options="data_campus" placeholder="--Seleccione una sede --"
                                    :value.sync="selectedCampus" @change="onCampusChange" />
                            </CCol>
                            <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                                <CInput label="Desde" type="date" aria-label="shift_date" @input="onCampusChange"
                                    size="sm" id="init" v-model="filter.init" />
                            </CCol>
                            <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                                <CInput label="Hasta" type="date" aria-label="shift_date" @input="onCampusChange"
                                    id="end" size="sm" v-model="filter.end" />
                            </CCol>
                            <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                                <CInput label="Total de Registros" type="text" size="sm" v-model="totalCompras"
                                    disabled />
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol xs="12" sm="12" md="8" lg="8" xl="9">
                <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
                    caption="Lista de movimientos" icon="fas fa-solid fa-truck" @mtdBack="mtdBack" :size="'md'"
                    :withActions="'2%'" :actions="true" :myButtons="myButtons"
                    @mtd_detail_movement="mtd_detail_movement">
                </CTableWrapper>
            </CCol>
        </CRow>

    </div>
</template>

<script>
const fields = [
    { key: "index", label: "ID", _style: "width:1%" },
    { key: "date_formatted", label: "Fecha", _style: "width:5%;" },
    { key: "almacen_salida", label: "Almacen Origen", _style: "width:10%;" },
    { key: "envia", label: "Envía", _style: "width:10%;" },
    { key: "almacen_llegada", label: "Almacen Destino", _style: "width:10%;" },
    { key: "prd", label: "Productos", _style: "width:40%;" },
    // { key: "product", label: "Producto", _style: "width:10%;" },
    // { key: "quantity", label: "Cantidad", _style: "width:10%;" },

];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
    components: {
        CTableWrapper,

    },
    data() {
        return {
            prefix: "stock_transfer",
            fields,
            data: [],
            data_campus: [],
            totalCompras: 0,
            filter: {
                init: null,
                end: null,
            },
            labelIcon: {
                labelOn: "\u2713",
                labelOff: "\u2715",
            },
            componentKey: 0,
            selectedCampus: null,
            myButtons: [
                {
                    class: "btn-sm",
                    color: "primary",
                    tooltip: "Detalle de movimiento",
                    action: "mtd_detail_movement",
                    icon: "fas fa-file-pdf",
                },
            ],
        };
    },
    computed: {
        cpStatus: function () {
            if (this.companies.state == 1) return true;
            return false;
        },
    },
    created() {
        moment.locale("es");
        this.filter.end = moment().format("YYYY-MM-DD");
        this.filter.init = this.filter.end;
        this.mtd_data();
        this.getCampus();
    },
    methods: {
        ...mapActions(["get", "post"]),
        getCampus() {
            this.get({
                url:
                    this.$store.getters.get__url +
                    "/stock_transfer/showAlmacenes/" +
                    this.$store.getters.get_campu.id,
                token: this.$store.getters.get__token,
            }).then((response) => {
                if (response.statusCode == 200) {
                    this.data_campus = [
                        { label: "Todos", value: null },
                        ...response.data.map((element) => ({
                            label: element.name,
                            value: element.id,
                        })),
                    ];
                }
            });
        },
        onCampusChange() {
            if (this.selectedCampus === null) {
                this.mtd_data();
            } else {
                this.mtd_data(this.selectedCampus);
            }
        },
        mtd_data(campuId = null) {
            if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Por favor, selecciona un rango de fechas válido.',
                });
            }
            this.post({
                url: this.$store.getters.get__url + "/" + this.prefix + "/showStockTransfer",
                token: this.$store.getters.get__token,
                params: {
                    init: this.filter.init,
                    end: this.filter.end,
                    campu_id: campuId,
                    company_id: this.$store.getters.get_company.id,
                },
            })
                .then((response) => {
                    this.clearData();
                    this.data = response.data;
                    this.data.forEach((item) => {
                        let stringPrd = this.mtdCastPrd(JSON.parse(item.productos));
                        item.date_formatted = moment(item.date).format("DD/MM/YYYY");
                        item.almacen_salida = item.old_almacen?.name ?? "-";
                        item.envia = item.user_envia?.name + ' ' + item.user_envia?.last_name ?? "-";
                        item.almacen_llegada = item.new_almacen?.name ?? "-";
                        item.prd = stringPrd;
                        // this.product = item.productos;
                        // this.quantity = item.prod.quantity
                    });
                    let index = 1;
                    this.data.forEach((arr) => {
                        arr.index = index;
                        index++
                    });
                    // this.data = [];
                    // let index = 1;
                    // response.data.forEach((transfer) => {
                    //     let productos = [];
                    //     try {
                    //         productos = JSON.parse(transfer.productos);
                    //     } catch (e) {
                    //         console.error("Error al parsear productos", transfer.productos);
                    //         return;
                    //     }

                    //     productos.forEach((prod) => {
                    //         this.data.push({
                    //             index: index++,
                    //             date_formatted: moment(transfer.date).format("DD/MM/YYYY"),
                    //             almacen_salida: transfer.old_almacen?.name ?? "-",
                    //             almacen_llegada: transfer.new_almacen?.name ?? "-",
                    //             product: prod.product.name,
                    //             quantity: prod.quantity,
                    //         });
                    //     });
                    // });
                    // this.totalCompras = this.data.length;
                })
                .catch((errors) => {
                    Swal.fire({
                        title: errors,
                        icon: "danger",
                    });
                });
        },
        mtdBack: function () {
            this.$emit("mtdBack");
        },
        clearData() {
            this.data = [];
            this.totalCompras = 0;
        },
        mtd_detail_movement(item) {

            window.open(
                this.$store.getters.get__url + "/stock_transfer/detail-movement/" + item.id + "/" + this.$store.getters.get__user_id + "/" + item.index,
                "_blank"
            );
        },
        mtdCastPrd: function(payload){
            let res = "";
            payload.forEach(element => {
                res += element.product.name+",";
            });
            return res;
        }
    },

};
</script>

<style lang="scss" scoped></style>